import * as React from 'react'
import Link from 'next/link'
import { Container } from '../Container'
import { Button } from '../Button'
import { useQueryParam } from '../../hooks/useQueryParam'
import image from '../../../public/img/nubrakes-brake-repair-header.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
export const MinorCityFourthSection: React.FC<{
  title: string
  subheading: string
}> = ({ title, subheading }) => {
  const query = useQueryParam()
  return (
    <section
      // not refactoring this one b/c I don't have any way to reproduce examples. Jake let me know that they created major city pages for all minor cities
      className="full-width-image top-section"
      style={{
        backgroundImage: `url(${image.src})`,
        backgroundPosition: `top left`,
        backgroundAttachment: `fixed`,
      }}
    >
      <Container className={'text-center'}>
        <div className="grid md:grid-cols-2">
          <div className="text-left flex flex-col flex-grow justify-center">
            <div className="">
              <h2 style={{ fontSize: 29, color: 'white' }}>{title}</h2>
              <p style={{ color: '#cbd0d3', fontSize: 16 }}>{subheading}</p>
            </div>
          </div>
          <div>
            <div style={{ padding: '20px 45px' }} className="bg-white">
              <h2 className="text-black">Perks of NuBrakes</h2>
              <Perk perkText={`We Come To You`} />
              <Perk perkText={`Save Up To 40% On Average`} />
              <Perk perkText={`Zero Markup On Parts — Ever`} />
              <Perk perkText={`ASE Certified Brake Techs`} />
              <Link href={{ pathname: `/get-quote/`, query }} passHref={true}>
                <Button
                  className="w-full py-2"
                  style={{ fontSize: 15, fontWeight: 'bold' }}
                >{`GET A FREE QUOTE NOW`}</Button>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

const Perk: React.FC<{ perkText: string }> = ({ perkText }) => (
  <div className={'flex flex-row items-center py-1'}>
    <FontAwesomeIcon icon={faCheckCircle} style={{ fontWeight: 100 }} color={'#bfbfbf'} size={'3x'} />
    <p className="pl-3" style={{ color: '#a6adb4' }}>
      {perkText}
    </p>
  </div>
)
